module.exports = __webpack_public_path__ + "media/application/images/icons/print-cb4e04cddfd753f40a5f74632effc22a.svg";